import { sumCNYFormat, sumUSDFormat, USDollar } from 'utils/format';
import { formatCurrency } from 'utils/format';
export function InvestorPositionsTableByAccountDetailed(props) {
    const { positions, usdPositions, cnyPositions } = props;

    const cnyBorderTop = usdPositions.length > 0 ? '1px solid black' : '';

    return (
        <div style={{}}>
            {usdPositions.map((position, idx) => (
                <div
                    key={idx}
                    style={{
                        display: 'flex',
                        borderTop: idx === 0 ? '' : '1px solid black',
                    }}
                >
                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {position.fund_name}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {position.funding_receipt_date.slice(0, 10)}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.investment_amount,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.account_balance,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.interest_received,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.principal_returned,
                            position.currency
                        )}
                    </div>
                </div>
            ))}

            {usdPositions.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        borderTop: '1px solid black',
                        fontWeight: 'bold',
                    }}
                >
                    <div style={{ width: '100px', textAlign: 'center' }}>
                        Sum USD
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumUSDFormat(usdPositions, 'investment_amount')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumUSDFormat(usdPositions, 'account_balance')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumUSDFormat(usdPositions, 'interest_received')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumUSDFormat(usdPositions, 'principal_returned')}
                    </div>
                </div>
            )}

            {cnyPositions.map((position, idx) => (
                <div
                    key={idx}
                    style={{
                        display: 'flex',
                        borderTop: cnyBorderTop,
                    }}
                >
                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {position.fund_name}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {position.funding_receipt_date.slice(0, 10)}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.investment_amount,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.account_balance,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.interest_received,
                            position.currency
                        )}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {formatCurrency(
                            position.principal_returned,
                            position.currency
                        )}
                    </div>
                </div>
            ))}
            {cnyPositions.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        borderTop: '1px solid black',
                        fontWeight: 'bold',
                    }}
                >
                    <div style={{ width: '100px', textAlign: 'center' }}>
                        Sum CNY
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumCNYFormat(cnyPositions, 'investment_amount')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumCNYFormat(cnyPositions, 'account_balance')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumCNYFormat(cnyPositions, 'interest_received')}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}>
                        {sumCNYFormat(cnyPositions, 'principal_returned')}
                    </div>
                </div>
            )}
        </div>
    );
}
